module.exports = __webpack_public_path__ + "img/24@2x.aaeb44d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/24@2x.png
// module id = oWD5
// module chunks = 0